import { render, staticRenderFns } from "./DeleteUsers.vue?vue&type=template&id=68cb64cd&"
import script from "./DeleteUsers.vue?vue&type=script&lang=js&"
export * from "./DeleteUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports